<div
  id="powerbiReport"
  #reportContainer
  [style.height.px]="reportConfig.height"
></div>
